import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { AppDispatch, RootState } from '@app/store/store';

import { authExpired, selectIsAuthenticated } from './authentication.slice';
import { invokeLogout } from './authentication.thunks';

export const authListenerMiddleware = createListenerMiddleware();

const startListening = authListenerMiddleware.startListening.withTypes<RootState, AppDispatch>();

startListening({
  actionCreator: authExpired,
  effect: async (_action, listenerApi) => {
    /**
     * Prevent an endless logout loop.
     * * Sometimes, this `authExpired` action fires when the user is ALREADY logged out
     * (e.g., a delayed 401 error arrives, or another tab just logged them out).
     * * If we run the logout process again, it triggers a chain reaction:
     * 1. We run `invokeLogout` which clears the data cache.
     * 2. The UI notices missing data and tries to re-fetch it.
     * 3. The server responds with a 401 error (because we have no token).
     * 4. The 401 error triggers `authExpired` all over again.
     * * Solution: If the user is already unauthenticated, just bail out and do nothing.
     */
    if (!selectIsAuthenticated(listenerApi.getState())) {
      return;
    }
    await listenerApi.dispatch(invokeLogout());
  },
});
